// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment/types';
import { type IncomingPayment, getHash } from '@tectonics/prs/incoming-payment';
import { type UserInputValues } from '@tectonics/prs/user-input-values';

export function incomingPaymentMapper(
  userInputValues: UserInputValues,
  incomingPayment: IncomingPayment,
): $Shape<OutgoingPayment> {
  return {
    hash: getHash(incomingPayment),
    merchant_payment_code: incomingPayment['merchant_payment_code'],
  };
}
